import { connect } from 'react-redux';
import KeycloakTracker from '../../../api/keycloak/KeycloakTracker';
import fetchMasToken from '../../../api/keycloak/tokenActions';
import { selectors } from '../../../root/reading/root';

const mapStateToProps = state => ({
    shouldValidateSession: selectors.shouldValidateSession(state),
    isMasTokenFetched: selectors.isMasTokenFetched(state),
});

const mapDispatchToProps = dispatch => ({
    fetchMasToken: () => {
        dispatch(fetchMasToken());
    },
});

const KeycloakTrackerContainer = connect(mapStateToProps, mapDispatchToProps)(KeycloakTracker);

export default KeycloakTrackerContainer;
